<template>
    <CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
            <div class="row">
                <div class="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9">
                    <div class="card-calendar">
                        <div id="calendario" class="calendario">
                            <FullCalendar :options="calendarOptions" />
                        </div>
                    </div>
                </div>

                <div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 bg-01">
                    <template v-if="segurity.AddAgenda">
                        <button type="button"  @click="AbrirModalAgenda({})" class="btn btn-primary position-absolute mt-3">
                            <i class="fas fa-calendar-plus"></i> Nuevo
                        </button>
                    </template>

                    <h4 class="text-end text-green-black mt-2">Agenda Hoy</h4>
                    <p class="text-end mt-n2" >{{Fecha}}</p>
                    <hr class="horizontal dark">

                    
                    <ul class="nav nav-tabs" id="myTab" role="tablist">
                        <li class="nav-item" role="presentation">
                            <button class="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home-tab-pane" type="button" role="tab" aria-controls="home-tab-pane" aria-selected="true">Eventos</button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile-tab-pane" type="button" role="tab" aria-controls="profile-tab-pane" aria-selected="false">Actividades</button>
                        </li>
                    </ul>

                    <div class="tab-content" id="myTabContentCal">
                        <div class="tab-pane fade scroll-ve show active" id="home-tab-pane" role="tabpanel" aria-labelledby="home-tab" tabindex="0">
                            <ol class="list-group list-group-flush list-group-numbered">
                                <li v-for="(item,index) in EventosDelDia" :key="index" class="list-group-item bg-00" @click="AbrirModalResumen(item.IdCotz)">
                                    {{item.title}}
                                </li>
                                <!-- <li class="list-group-item bg-00">Reunión con Ana</li>
                                <li class="list-group-item bg-00">Boda de Laura & Bronson</li>
                                <li class="list-group-item bg-00">Boda Estefania Maldonado & Aleksey Babadzhanov</li>
                                <li class="list-group-item bg-00">Fiesta Ramón Vázquez</li>
                                <li class="list-group-item bg-00">Fiesta Brooke Miller</li>
                                <li class="list-group-item bg-00">Reunión con Ana</li>
                                <li class="list-group-item bg-00">Boda de Laura & Bronson</li>
                                <li class="list-group-item bg-00">Boda Estefania Maldonado & Aleksey Babadzhanov</li>
                                <li class="list-group-item bg-00">Fiesta Ramón Vázquez</li>
                                <li class="list-group-item bg-00">Fiesta Brooke Miller</li>
                                <li class="list-group-item bg-00">Reunión con Ana</li>
                                <li class="list-group-item bg-00">Boda de Laura & Bronson</li>
                                <li class="list-group-item bg-00">Boda Estefania Maldonado & Aleksey Babadzhanov</li>
                                <li class="list-group-item bg-00">Fiesta Ramón Vázquez</li>
                                <li class="list-group-item bg-00">Fiesta Brooke Miller</li> -->
                            </ol>
                        </div>
                        
                        <div class="tab-pane fade scroll-ve" id="profile-tab-pane" role="tabpanel" aria-labelledby="profile-tab" tabindex="0">
                            <ol class="list-group list-group-flush list-group-numbered">
                                <li v-for="(item,index) in AgendaDelDia" :key="index" class="list-group-item bg-00" @click="AbrirModalAgenda(item)">
                                    {{item.title}}
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>

                <CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSave">
					<template slot="Form">
						<Form :poBtnSave="oBtnSave"></Form>
					</template>
				</CModal>

                <CModal :pConfigModal="ConfigModal2" :poBtnSave="oBtnSave2">
					<template slot="Form">
						<FormDetalle :poBtnSave="oBtnSave2"></FormDetalle>
					</template>
				</CModal>
            </div>
        </template>
    </CLoader>
</template>

<script>

import Form from '@/views/modulos/crm/agenda/Form.vue';
import FormDetalle from '@/views/modulos/crm/calendario/FormResumen.vue';
import moment from 'moment';
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionAsignarPersonal';
const EmitEjecuta2 = 'seccionAgenda';
const EmitEjecuta3 = 'seccionDetalleEventos';

import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from '@fullcalendar/interaction';
import esLocale from "@fullcalendar/core/locales/es";
import { dA } from '@fullcalendar/core/internal-common';

export default {
    name: 'CalendarioData',
    props: [],
    components: {
        Form,
        FullCalendar,
        FormDetalle,
    },
    data() {
        var self = this;
        return {
            ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            ConfigModal:{
                ModalTitle: "Agenda",
                ModalNameId: 'ModalFormAg',
                EmitSeccion: EmitEjecuta2,
                ModalSize: 'lg',
            },
            oBtnSave: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta2,
                ShowBtnSave: true,
            },
            ConfigModal2:{
                ModalTitle: "Detalle Eventos",
                ModalNameId: 'ModalFormEv',
                EmitSeccion: EmitEjecuta3,
                ModalSize: 'lg',
                ShowFooter: false,
            },
            oBtnSave2: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta3,
            },
            segurity: {},
            errorvalidacion: [],
			Emit: EmitEjecuta,
            Fecha: moment(new Date()).format('DD/MM/YYYY'),
            EventosDelDia: [],
            AgendaDelDia: [],
            ListaEventos: [],
            AnioActivo: moment(new Date()).format('YYYY'),

            calendarOptions: {
                plugins: [ dayGridPlugin, interactionPlugin, timeGridPlugin ],
                headerToolbar: {
                    left: 'prev,next today',//prevYear,,nextYear
                    center: 'title',
                    right: 'dayGridMonth,timeGridWeek,timeGridDay'
                },
                contentHeight: 600,
                initialView: 'dayGridMonth',
                locales: [ esLocale ],
                locale: 'es',
                weekends: true,
                /* height:500,
                aspectRatio: 2, */
                dateClick: function(info) {
                    self.GetEventosPorDia(info.dateStr);
                },
                
                dayMaxEventRows: true, // for all non-TimeGrid views
                views: {
                    dayGrid: {
                        dayMaxEventRows: 4, // adjust to 6 only for timeGridWeek/timeGridDay
                        moreLinkClick: 'week',
                        eventClick: function (calEvent, jsEvent, view) {
                            let IdCotzEvento = calEvent.event.id;
                            let valor = self.calendarOptions.events.filter(function(element){
                                return (element.id == IdCotzEvento) ? element: '';
                            });

                            if(valor[0])
                            {
                                if(valor[0].Tipo == 'Agenda'){
                                    self.AbrirModalAgenda(valor[0]);
                                }
                                else{
                                    self.AbrirModalResumen(valor[0].IdCotz);
                                }
                                self.GetEventosPorDia(valor[0].start);
                            }
                            else{
                                self.$toast.info('No se encontro información del evento');
                            }
                        },
                    },
                    timeGrid: {
                       dayMaxEventRows: 3,
                       eventClick: function (calEvent, jsEvent, view) {
                            alert('hola2')
                        },
                    }
                },
                eventDisplay: 'block',
                eventColor: '#00a389',
                events:[],
                datesSet: this.handleMonthChange,
                /*
                events: [
                    {
                        id: 'a',
                        title: 'my event 1',
                        start: '2023-09-01',
                        color: this.GetColorExa(),
                        allDay: false,
                    },
                    {
                        id: 'a',
                        title: 'my event 2',
                        start: '2023-09-01 17:30:00',
                        color: this.GetColorExa(),
                    },
                    {
                        id: 'a',
                        title: 'my event 3',
                        start: '2023-09-01 18:30:00',
                        color: this.GetColorExa(),
                    },
                    {
                        id: 'a',
                        title: 'my event 4',
                        start: '2023-09-01 19:30:00',
                        color: this.GetColorExa(),
                    },
                    {
                        id: 'a',
                        title: 'my event 5',
                        start: '2023-09-01 20:30:00',
                        color: this.GetColorExa(),
                    },
                    {
                        id: 'a',
                        title: 'my event 6',
                        start: '2023-09-01 21:30:00',
                        color: this.GetColorExa(),
                    },
                    {
                        id: 'a',
                        title: 'my event 7', 
                        start: '2023-09-01 22:00:00',
                        color: this.GetColorExa(),
                    },
                    {
                        id: 'a',
                        title: 'my event 8',
                        start: '2023-09-01 22:10:00',
                        color: this.GetColorExa(),
                    },
                    {
                        id: 'a', 
                        title: 'my event 9',
                        start: '2023-09-01 22:20:00',
                        color: this.GetColorExa(),
                    },
                    {
                        id: 'a',
                        title: 'my event 10',
                        start: '2023-09-01 22:30:00',
                        color: this.GetColorExa(),
                    },
                ]*/
            },
        }
    },
    methods: {
        async Lista()
        {
            let Fecha = '';
            //if(this.Fecha == ''){
                Fecha = this.AnioActivo;//moment(new Date()).format('YYYY');
            //}
            this.ConfigLoad.ShowLoader = true;
            this.calendarOptions.events = [];

            await this.$http.get("calendarios",{
                params:{
                    Fecha: Fecha,
                }
            }).then((res) => {
                
                let arreglo = res.data.data;
                let arreglo2 = res.data.agenda;
                let idsDinamicos = res.data.IdsRandom;

                let arr = [];
                let setColor = this;

                arreglo.forEach(function (element){
                    let addId = (idsDinamicos.length>0)? idsDinamicos[0]:0;

                    let obj = {
                        id: addId,
                        title: element.Nombres,
                        start: element.FechaEvento,//+' '+element.HoraEvento,
                        color: setColor.GetColorExa(),
                        IdCotz: element.IdCotizacion,
                        IdCotzEvento: element.IdCotizacionEvento,
                        IdCliente: element.IdCliente,
                        IdAgenda: 0,
                        Nombres: element.Nombres,
                        Tipo: 'Eventos',
                    };

                    arr.push(obj);

                    if(idsDinamicos.length>0){
                        idsDinamicos.shift();
                    }
                });

                arreglo2.forEach(function (element){
                    let addId = (idsDinamicos.length>0)? idsDinamicos[0]:0;

                    let obj = {
                        id: addId,
                        title: element.Nombre+' a '+element.Nombres,
                        start: element.Fecha,//+' '+element.HoraEvento,
                        color: setColor.GetColorExa(),
                        IdCotz: 0,
                        IdCotzEvento: 0,
                        IdCliente: element.IdCliente,
                        IdAgenda: element.IdAgenda,
                        Nombres: element.Nombres,
                        Tipo: 'Agenda',
                    };

                    arr.push(obj);

                    if(idsDinamicos.length>0){
                        idsDinamicos.shift();
                    }
                });

                this.calendarOptions.events = arr;
                this.ListaEventos = arr;
                this.segurity = res.data.segurity;
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        AbrirModalAgenda(item)
        {
            let IdCliente = 0;
            let IdAgenda = 0;
            let Nombres = '';

            if(Object.keys(item).length !== 0)
            {
                IdAgenda = item.IdAgenda;
                IdCliente = item.IdCliente;
                Nombres = item.Nombres;
            }

            let obj = {
                Lugar: 'Calendario',
                IdCliente: IdCliente,
                Nombres: Nombres,
            }
            this.bus.$emit('NewModal_'+EmitEjecuta2,IdAgenda,obj);
        },
        AbrirModalResumen(IdCotizacion)
        {
            this.bus.$emit('NewModal_'+EmitEjecuta3,IdCotizacion,{});
        },
        GetColorExa(){
            return '#'+Math.floor(Math.random()*16777215).toString(16);
        },
        GetEventosPorDia(Fecha)
        {
            let aBuscar = Fecha;

            let access = this.calendarOptions.events.filter(function(element){
                if(element.start == aBuscar && element.Tipo == 'Eventos'){
                    return element;
                }
                else{
                    return '';
                }
            });

            let access2 = this.calendarOptions.events.filter(function(element){
                if(element.start == aBuscar && element.Tipo == 'Agenda'){
                    return element;
                }
                else{
                    return '';
                }
            });

            if(access[0]){
                this.EventosDelDia = access;
            }else{
                this.EventosDelDia = [];
            }

            if(access2[0]){
                this.AgendaDelDia = access2;
            }else{
                this.AgendaDelDia = [];
            }
            this.Fecha = moment(aBuscar).format('DD/MM/YYYY');
        },
        handleMonthChange(info)
        {
            let FechaEntrante = moment(info.view.currentStart).format('YYYY-MM-DD');
            let AnioEntrante = FechaEntrante.split('-')[0];

            if(this.AnioActivo != AnioEntrante){
                this.AnioActivo = AnioEntrante;
                this.Lista();
            }
        }
    },
    created()
    {
        this.bus.$off('reloadCalendar');
    },
    mounted()
    {
        this.Lista();
        this.ConfigLoad.ShowLoader = false;

        this.bus.$on('reloadCalendar',()=>
        {
            this.Lista();
        });
    }
}
</script>
